import type { ChatFlowStrategy, FlowContext } from './types';

export interface FlowExecutorOptions {
  timeoutMs?: number;
  onTimeout?: () => void;
  onError?: (error: unknown) => void;
}

/**
 * 统一的流程执行器，封装超时控制与通用异常入口。
 */
export async function executeFlow(
  strategy: ChatFlowStrategy,
  question: string,
  context: FlowContext,
  options: FlowExecutorOptions = {},
): Promise<void> {
  const { timeoutMs = 10 * 60 * 1000, onTimeout, onError } = options;

  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  let didTimeout = false;

  try {
    const timeoutPromise = new Promise<never>((_, reject) => {
      timeoutId = setTimeout(() => {
        didTimeout = true;
        onTimeout?.();
        reject(new Error('Flow execution timeout'));
      }, timeoutMs);
    });

    await Promise.race([strategy.sendMessage(question, context), timeoutPromise]);
  } catch (error) {
    onError?.(error);
    throw error;
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // 若已超时，由调用方 onTimeout 触发中止；这里不再做额外处理。
    if (didTimeout) {
      return;
    }
  }
}
